import React from "react";
import {
  ReferralContestTCCard,
  ReferralContestTCContainer,
} from "./ReferralContestTC.styled copy";

const ReferralContestTC = () => {
  return (
    <ReferralContestTCContainer>
      <ReferralContestTCCard>
        <p>Pubmining Referral Contest Terms and Conditions</p>

        <p>
          Eligibility: The Pubmining Referral Contest is open to all registered
          Pubmining platform users who have an active and verified account.
        </p>

        <p>
          Contest Period: The contest will start on June 5th, 2023, until July
          31st, 2023.
        </p>

        <p>
          Participation: To participate in the referral contest, users must
          refer new members to join Pubmining using their referral link. Only
          referrals made during the contest period will be considered eligible.
        </p>

        <p>
          Referral Tracking: Referrals will be tracked automatically through the
          referral links generated for each user. It is the responsibility of
          participants to ensure that their referrals use the provided link when
          signing up.
        </p>

        <p>
          Contest Prizes: Prizes will be awarded based on the number of
          successful referrals made by participants during the contest period.
          The specific prizes and their corresponding referral thresholds will
          be announced prior to the start of the contest. Participants can refer
          as many users as they want to increase their chances of winning.
        </p>

        <p>
          Prize Distribution: The winners of the referral contest will be
          announced within a reasonable time after the contest ends. Prizes will
          be distributed to the winners' Pubmining accounts or any other method
          specified by Pubmining. The distribution process and timeline will be
          communicated to the winners individually.
        </p>

        <p>
          Fair Play: Participants are expected to engage in fair play throughout
          the contest. Any fraudulent, deceptive, or unethical practice to gain
          referrals will result in disqualification from the contest. Pubmining
          reserves the right to determine the eligibility of referrals and
          disqualify any participant found in violation of the terms and
          conditions.
        </p>

        <p>
          Modification or Termination: Pubmining reserves the right to modify,
          suspend, or terminate the referral contest at any time and for any
          reason. In such cases, participants will be notified in advance, and
          the applicable terms for prize distribution or alternative
          arrangements will be communicated.
        </p>
        <p>
          General Conditions: By participating in the referral contest,
          participants agree to abide by these terms and conditions and
          Pubmining's overall terms of service. Pubmining reserves the right to
          make final decisions regarding the contest, including but not limited
          to eligibility, winners, and prize distribution.
        </p>
        <p>
          Privacy: Any personal information collected during the referral
          contest will be used solely for the purpose of administering the
          contest and distributing prizes. Pubmining will handle all personal
          data in accordance with its privacy policy.
        </p>
        <p>
          Please read these terms and conditions carefully before participating
          in the Pubmining Referral Contest. By participating, you acknowledge
          and agree to these terms.
        </p>
      </ReferralContestTCCard>
    </ReferralContestTCContainer>
  );
};

export default ReferralContestTC;
